import { AfterViewInit, Component, OnInit, ElementRef, ViewChild, AfterViewChecked } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { AppraisalCommunication } from 'src/app/models/Appraisal'
import { NotifyRequester } from 'src/app/models/Demand'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { DemandService } from 'src/app/services/demand.service'
import { NotificationService } from 'src/app/services/notification.service'
import { removeToolTip } from 'src/app/_helpers/Utils'

@Component({
		selector: 'communication-appraisal',
		templateUrl: './communicationAppraisal.component.html'
})
export class CommunicationAppraisal implements OnInit, AfterViewInit {

		constructor(
				private readonly router: Router,
				private readonly routeActive: ActivatedRoute,
				private readonly demandService: DemandService,
				private readonly notificationService: NotificationService
		) { }

		@ViewChild('myCommunication') public myCommunication: ElementRef

		public ngAfterViewInit(): void {
				const body = document.body

				body.style.transition = 'background-color 0.5s ease-in-out'
				body.style.backgroundColor = '#dedede'
		}

		public companyId: string = localStorage.getItem('companyId')
		public sessionUser: UserAdmin = getLoggedUser()

		public isAdmin: boolean = false
		public demandId: string = ''
		public appraisalsIds: string = ''
		public isCustomerOrUser: boolean = false
		public isEvaluator: boolean = false
		public isLoading: boolean = true
		public enableNotifyCommunication: boolean = false
		public enableUnassignCommunication: boolean = false
		public openModalUnassignComnunications: boolean = false
		public openModalNotfy: boolean = false
		public closeCommunication: boolean = false

		public communications: Array<AppraisalCommunication> = []

		public async ngOnInit() {

				this.isAdmin = Boolean(
						this.sessionUser.roles.includes('GENERAL_ADMIN')
				)
				this.isCustomerOrUser = Boolean(
						this.sessionUser.roles.includes('CUSTOMER') ||
						this.sessionUser.roles.includes('USER')
				)
				this.isEvaluator = Boolean(
						this.sessionUser.roles.includes('EVALUATOR')
				)

				await this.getCommunications()
				this.setEnableControllers()
		}

		public async getCommunications(): Promise<void> {
				this.appraisalsIds = this.routeActive.snapshot.paramMap.get('appraisalIds')
				this.demandId = this.routeActive.snapshot.queryParamMap.get('demandId')

				try {
						const communications =
								await this.demandService.getCommunications(this.companyId, this.appraisalsIds, this.demandId).toPromise()

						const sortedCommunications = communications.sort((a, b) => a.identification.localeCompare(b.identification))

						this.communications = sortedCommunications
				} catch (error) {
						this.router.navigate(['/redirect'])
				}

				this.isLoading = false
		}

		public setEnableControllers() {
				this.enableNotifyCommunication = Boolean(
						this.communications.every(communication => communication.assign) &&
						this.communications.some(communication => !communication.done) &&
						(this.isAdmin || this.sessionUser.assignments.includes('APPRAISAL_HISTORY_NOTIFY'))
				)

				this.enableUnassignCommunication = this.enableNotifyCommunication
		}

		public async printOut() {

				this.removeOrInsertClassNotPrint(true)

				setTimeout(() => {
						window.print()
						this.removeOrInsertClassNotPrint(false)
				}, 200)
		}

		public openCloseModalUnassign() {
				this.openModalUnassignComnunications = !this.openModalUnassignComnunications

				removeToolTip()
		}

		public async unassignCommunication(): Promise<void> {
				try {
						this.notificationService.initLoading()

						const appraisalsIds: Array<string> =
								this.communications.map(communication => communication.idMongo)

						const response: string =
								await this.demandService.unAssignCommunication(appraisalsIds).toPromise()

						this.notificationService.notify(response, 200)
						this.triggerUnassignReportEvent()
				} catch (error) {
						this.notificationService.notify(error.error.message, error.error.statusCode || 400)
				} finally {
						this.openCloseModalUnassign()
						this.notificationService.stopLoading()

						this.closeCommunication = true
				}
		}

		public openCloseModalNotify() {
				this.openModalNotfy = !this.openModalNotfy

				removeToolTip()
		}

		public async notifyRequester() {
				try {
						this.notificationService.initLoading()

						const nativeHtml = this.myCommunication.nativeElement.innerHTML
						const appraisalsIds: Array<string> =
								this.communications.map(communication => communication.idMongo)

						const body: NotifyRequester = {
								appraisalsIds,
								html: nativeHtml
						}

						if (this.demandId) {
								body.demandIds = [this.demandId]
						}

						const response: string =
								await this.demandService.notifyRequester(this.companyId, body).toPromise()

						this.notificationService.notify(response, 200)
						this.triggerDoneReportEvent(appraisalsIds)
						this.reloadWindow()
				} catch (error) {
						this.notificationService.notify(error.error.message, error.error.statusCode || 400)
				} finally {
						this.openCloseModalNotify()
						this.notificationService.stopLoading()
				}
		}

		public removeOrInsertClassNotPrint(remove: boolean) {
				const communications = document.getElementsByClassName('content-comuinication')

				if (remove) {
						for (let i = 0; i < communications.length; i++) {
								communications[i].classList.remove('not-printing')
						}
				} else {
						for (let i = 0; i < communications.length; i++) {
								communications[i].classList.add('not-printing')
						}
				}
		}

		public reloadWindow() {
				setTimeout(() => {
						window.location.reload()
				}, 500)
		}

		public closeWindow() {
				window.close()
		}

		public triggerUnassignReportEvent() {
				const appraisalIds: Array<{ idMongo: string, cpfRequester: string }> =
						this.communications.map(communication => {
								return {
										idMongo: communication.idMongo,
										cpfRequester: communication.cpfRequester
								}
						})


				localStorage.setItem(
						'unassignReport',
						JSON.stringify(appraisalIds)
				)
		}

		public triggerDoneReportEvent(appraisalsIds: Array<string>) {
				localStorage.setItem(
						'doneReport',
						`The communications from appraisals ${appraisalsIds} has send now: ${new Date().getTime()}`
				)
		}
}
